import { MediaLibrary } from '@features/mediaLibrary/components/MediaLibrary'
import { createFileRoute } from '@tanstack/react-router'

const MediaLibraryRoute = () => <MediaLibrary />

export const Route = createFileRoute('/_auth/o/$orgId/mediaLibrary/')({
  component: MediaLibraryRoute,
})
